module.exports = __webpack_public_path__ + "img/AGC.57821653.png";